<script lang="ts" setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    required: false,
    default: '',
  },
  customClass: {
    type: String,
    required: false,
    default: '',
  },
  tag: {
    type: String as () => 'h1' | 'h2' | 'h3',
    default: 'h2',
  },
})
const { isMobile } = useDevice()
const slots = useSlots()
</script>

<template>
  <section :id="props.id" class="base-section" :class="customClass">
    <div class="base-section__header" :class="[{ container: isMobile }]">
      <template v-if="slots['left-action']">
        <slot name="left-action" />
      </template>
      <template v-else>
        <div class="left-action">
          <slot v-if="slots.icon" name="icon" />
          <i
            v-else-if="props.icon"
            :class="{
              [props.icon]: true,
              'base-section__icon': true,
            }"
          />
          <component :is="tag" class="base-section__title">
            {{ props.title }}
          </component>
        </div>
      </template>
      <div class="base-section__right-action">
        <slot name="right-action" />
      </div>
    </div>
    <div class="base-section__content">
      <slot />
    </div>
  </section>
</template>
<style scoped></style>
